import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
});

export const uploadPhoto = async (file) => {
  const form = new FormData();
  form.append("file", file);
  const { data } = await api.post("/upload-photo", form, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return data;
};

export const createQuoteRequest = async (payload) => {
  const { data } = await api.post("/quote-requests", payload);
  return data;
};

// --- Admin ---
const authHeader = (token) => ({ Authorization: `Bearer ${token}` });

export const fetchAdminQuotes = async (token, { status = "all", sort = "created_at", order = "desc" } = {}) => {
  const { data } = await api.get("/admin/quote-requests", {
    headers: authHeader(token),
    params: { status, sort, order },
  });
  return data;
};

export const fetchAdminStats = async (token) => {
  const { data } = await api.get("/admin/quote-requests/stats", { headers: authHeader(token) });
  return data;
};

export const updateAdminQuote = async (token, id, patch) => {
  const { data } = await api.patch(`/admin/quote-requests/${id}`, patch, { headers: authHeader(token) });
  return data;
};
